import { render, staticRenderFns } from "./DefaultIcons.vue?vue&type=template&id=04341dec&scoped=true"
import script from "./DefaultIcons.vue?vue&type=script&lang=js"
export * from "./DefaultIcons.vue?vue&type=script&lang=js"
import style0 from "./DefaultIcons.vue?vue&type=style&index=0&id=04341dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04341dec",
  null
  
)

export default component.exports